module.exports = __webpack_public_path__ + "media/images/money-3c93a5024a751d1d84e28e18d7f84605.svg";